/* eslint-disable no-unused-vars */
import { useId } from 'react';
import {
  ArrowDown,
  ArrowRightForSelectedGroup,
  CheckTreeDivided,
  CheckTreeLine,
  CheckTreeDividedShort,
} from 'assets/icons';
import * as S from './ItemContent.styled';
import { Checkbox, ParagraphWithTooltip } from 'components';
import ReactCountryFlag from 'react-country-flag';

export const ItemContent = ({
  index,
  item,
  toggleContinent,
  isOpenedContinent,
  toggleCountry,
  isOpenedCountry,
  isActiveItem,
  toggleCheckedCountryOrRegion,
  childrenIsExcluded,
}) => {
  return (
    <>
      <S.ContinentRow onClick={() => toggleContinent(item.continent_code)}>
        <S.IconWrap isOpen={isOpenedContinent(item.continent_code)}>
          {isOpenedContinent(item.continent_code) ? <ArrowDown /> : <ArrowRightForSelectedGroup />}
        </S.IconWrap>
        <S.ContinentTitle>{item.continent_name}</S.ContinentTitle>
        <S.RowName>Continent</S.RowName>
      </S.ContinentRow>
      {isOpenedContinent(item.continent_code) && (
        <S.CountriesList>
          {item.countries.map((countryItem, index) => (
            <CountryElement
              key={index}
              countryItem={countryItem}
              isOpenedCountry={isOpenedCountry}
              toggleCountry={toggleCountry}
              isActiveItem={isActiveItem}
              toggleCheckedCountryOrRegion={toggleCheckedCountryOrRegion}
              childrenIsExcluded={childrenIsExcluded}
            />
          ))}
        </S.CountriesList>
      )}
    </>
  );
};

const CountryElement = ({
  countryItem,
  isOpenedCountry,
  toggleCountry,
  isActiveItem,
  toggleCheckedCountryOrRegion,
  childrenIsExcluded,
}) => {
  const countryCheckBoxId = useId();

  return (
    <S.CountryContainer>
      <S.CountryRow>
        <CheckTreeDivided />
        <S.IconWrap
          isOpen={isOpenedCountry(countryItem.country_code)}
          onClick={() => toggleCountry(countryItem.country_code)}
        >
          {isOpenedCountry(countryItem.country_code) ? (
            <ArrowDown />
          ) : (
            <ArrowRightForSelectedGroup />
          )}
        </S.IconWrap>
        <Checkbox
          id={countryCheckBoxId}
          isChecked={isActiveItem(countryItem, 'uniq_id')}
          name={countryItem.country_name}
          style={{ marginRight: '16px', marginLeft: '8px' }}
          onChange={() => toggleCheckedCountryOrRegion(countryItem, 'uniq_id')}
          //isOpenGroup={childrenIsExcluded(countryItem, 'uniq_id')}
        />
        <ReactCountryFlag
          countryCode={countryItem.country_code}
          svg
          style={{
            width: '20px',
            height: '15px',
            marginRight: '8px',
          }}
        />
        <S.CountryNameBox>
          <ParagraphWithTooltip
            text={`${countryItem.country_name} - ${countryItem.country_code}`}
          />
        </S.CountryNameBox>
        <S.RowName>Country</S.RowName>
      </S.CountryRow>
      {isOpenedCountry(countryItem.country_code) && (
        <S.RegionsList>
          {countryItem.regions.map((regionsItem, i) => (
            <RegionElement
              childrenIsExcluded={childrenIsExcluded}
              key={i}
              regionsItem={regionsItem}
              isActiveItem={isActiveItem}
              toggleCheckedCountryOrRegion={toggleCheckedCountryOrRegion}
            />
          ))}
        </S.RegionsList>
      )}
    </S.CountryContainer>
  );
};

const RegionElement = ({
  regionsItem,
  isActiveItem,
  toggleCheckedCountryOrRegion,
  childrenIsExcluded,
}) => {
  const regionCheckBoxId = useId();

  return (
    <S.RegionsRow>
      <CheckTreeLine />
      <CheckTreeDividedShort />
      <Checkbox
        id={regionCheckBoxId}
        isChecked={isActiveItem(regionsItem, 'uniq_id')}
        name={regionCheckBoxId}
        style={{ marginRight: '16px' }}
        onChange={() => toggleCheckedCountryOrRegion(regionsItem, 'uniq_id')}
        //isOpenGroup={childrenIsExcluded(regionsItem, 'uniq_id')}
      />
      <S.RegionNameBox>
        <ParagraphWithTooltip text={`${regionsItem.region_name}`} />
      </S.RegionNameBox>
      <S.RowName>Region</S.RowName>
    </S.RegionsRow>
  );
};
